import React from 'react';
import MenuItem from './MenuItem'; // Adjust the path as per your file structure
import { foodStock } from './FoodData'; // Importing the array from foodData

export default function MenuItemsContainer() {
  return (
    <div className="items-container">
      {foodStock.map((item, index) => (
        <MenuItem
          key={index} // Remember to provide a unique key for each item in the array
          imageSrc={item.imageSrc}
          title={item.title}
          description={item.description}
          price={item.price}
          isPopular={item.isPopular}
          isHearty={item.isHearty}
          isComfy={item.isComfy}
          isGluten={item.isGluten}
        />
      ))}
    </div>
  );
}
